import type { JSX } from 'react';
import type { ApprovalFilter } from '@/services/slaydAPI/posts';
import styles from '../ApprovalPortalPage.module.css';

interface PortalHeaderProps {
  searchType: 'id' | 'name' | 'title';
  setSearchType: (val: 'id' | 'name' | 'title') => void;
  searchValue: string;
  setSearchValue: (val: string) => void;
  activeFilter: ApprovalFilter;
  setFilter: (filter: ApprovalFilter) => void;
  totalCount: number;
  onSearch: () => void;
  filterOptions: { value: ApprovalFilter; label: string }[];
}

export const PortalHeader = ({
  searchType,
  setSearchType,
  searchValue,
  setSearchValue,
  activeFilter,
  setFilter,
  totalCount,
  onSearch,
  filterOptions,
}: PortalHeaderProps): JSX.Element => (
  <header className={styles.topbar}>
    <span className={styles.topbarBrand}>Approval Portal</span>

    <div className={styles.topbarSearch}>
      <select
        className={styles.searchSelect}
        value={searchType}
        onChange={(e) => {
          setSearchType(e.target.value as 'id' | 'name' | 'title');
          setSearchValue('');
        }}
      >
        <option value="id">ID</option>
        <option value="name">Curator</option>
        <option value="title">Title</option>
      </select>
      <input
        className={styles.searchInput}
        placeholder={`Search by ${searchType === 'id' ? 'ID' : searchType === 'title' ? 'title' : 'curator name'}…`}
        type="text"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && onSearch()}
      />
      <button
        className={styles.searchBtn}
        disabled={!searchValue.trim()}
        onClick={onSearch}
      >
        Go
      </button>
    </div>

    <div className={styles.topbarFilters}>
      {filterOptions.map((opt) => (
        <button
          key={opt.value}
          className={`${styles.filterBtn} ${activeFilter === opt.value ? styles.filterBtnActive : ''}`}
          onClick={() => setFilter(opt.value)}
        >
          {opt.label}
        </button>
      ))}
      {totalCount > 0 && (
        <span className={styles.topbarCount}>{totalCount}</span>
      )}
    </div>
  </header>
);
